<template>
    <div class="card mb-2">
        <div class="card-header pr-1 d-flex align-items-center">
            <span class="btnlike mr-auto">
                <h4 class="mb-0">Employee Information</h4>
            </span>

            <button v-if="canEdit" class="btn btn-outline-primary" type="button" @click.prevent="editInfoModalOpened = true">
                <i class="far fa-pen" aria-hidden="true" title="Edit"></i>
                Edit
            </button>
        </div>

        <div class="card-body">
            <div class="form-row">
                <div class="mui-textfield col-6">
                    <span class="textfield">{{ employee.full_name }}</span>
                    <label>Employee Name</label>
                </div>
                <div class="mui-textfield col-6">
                    <span class="textfield">{{ employee.first_name }}</span>
                    <label>Preferred Name</label>
                </div>
            </div>

           <div class="form-row">
                <div class="col-6">
                    <div class="mui-textfield">
                        <span class="textfield">XXX-XX-{{ employee.ssn_last_4 }}</span>
                        <label>Social Security Number</label>
                    </div>
                </div>
                <div class="col-6">
                    <button v-if="canEdit" class="btn btn-outline-primary btn-collapse-xl ml-hf" @click.prevent="editSSNModalOpened = true">
                        <i class="far fa-pen" aria-hidden="true" title="Edit"></i>
                        <span class="btn-text">Edit</span>
                    </button>
                </div>
            </div>

            <div class="mui-textfield">
                <span class="textfield">{{ $filters.date(employee.dob, 'MM/DD/Y') }}</span>
                <label>
                    Date of Birth
                </label>
            </div>

            <div class="mui-textfield">
                <span class="textfield">{{ employmentCategoryPretty }}</span>
                <label>Employment Category</label>
            </div>

            <div class="mui-textfield">
                <span class="textfield">{{ $filters.date(employee.date_hired) }}</span>
                <label>
                    <span v-if="employee.is_onboarding_application">Expected</span>
                    Start Date
                </label>
            </div>

            <div v-if="employee.employment_status == 'Terminated'" class="mui-textfield">
                <span class="textfield">{{ $filters.date(employee.date_terminated) }}</span>
                <label>
                    Termination Date
                </label>
            </div>

            <!-- TODO KB ES use client.has_gmps_terminations ?-->
            <div v-if="employee.employment_status != 'Terminated' && (employee.is_employee || $permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.TERMINATION_ROLES))">
                <button-row>
                    <button type="button" class="btn btn-outline-primary w-100" @click.prevent="terminateModalOpened = true">Terminate Employee</button>
                </button-row>
            </div>

        </div>
    </div>

    <EditEmployeeInfoModal
        :client="client"
        :employee="employee"
        v-if="editInfoModalOpened"
        @close="editInfoModalOpened = false"
        @updated="onUpdate"
    />

    <EditEmployeeSSNModal
        :client="client"
        :employee="employee"
        v-if="editSSNModalOpened"
        @close="editSSNModalOpened = false"
        @updated="onUpdate"
    />

    <TerminateEmployeeModal
        :client="client"
        :employee="employee"
        v-if="terminateModalOpened"
        @close="terminateModalOpened = false"
        @updated="onUpdate"
    />
</template>

<script>

import ButtonRow from '@/components/ButtonRow.vue'
import EditEmployeeInfoModal from './EditEmployeeInfoModal.vue'
import EditEmployeeSSNModal from './EditEmployeeSSNModal.vue'
import TerminateEmployeeModal from './TerminateEmployeeModal.vue'

export default {
    props: ['employee', 'client'],
    emits: ['updated'],
    components: {ButtonRow, EditEmployeeInfoModal, EditEmployeeSSNModal, TerminateEmployeeModal},
    data() {
        return {
            editInfoModalOpened: false,
            editSSNModalOpened: false,
            terminateModalOpened: false
        }
    },
    computed: {
        canEdit() {
            if (this.employee.is_employee && !this.$permissions.hasRolesInCompany(this.client.id, this.employee.company_id, this.$store.state.security_roles.EMPLOYEE_ROLES)) {
                return false  // Onboarding-only managers can't edit existing employees
            }
            // TODO KB ES check this logic
            return this.employee.is_employee || (this.employee.is_onboarding_application && this.employee.status != 'canceled')
        },
        employmentCategoryPretty() {
            if (this.employee.employment_category == 'PT') {
                return 'Part Time'
            } else if (this.employee.employment_category == 'FT') {
                return 'Full Time'
            }
        }
    },
    methods: {
        onUpdate() {
            this.$emit('updated')
        }
    },
}
</script>
